import { BRAND_NAME } from '../../config';
import { GLOBAL_LINKS } from '../../links';

const ENV = process.env.NEXT_PUBLIC_ENVIRONMENT || 'prod';
// Forms - component > forms > subscriber
export const SUBSCRIBER = {
  andCaps: 'AND',
  deliverable: 'DELIVERABLE',
  didYouMean: 'Did you mean?',
  goToDeals: 'go to deals',
  kickboxFailedValidation: 'Please enter a valid email address',
  leaveBlank: 'Please leave blank',
  lightboxAboveText: `By clicking GO TO DEALS! or LOGIN you agree to receive daily emails 
  featuring local service, shopping and travel offers from ${BRAND_NAME}.`,
  lightboxBelowText: `You can change your email preferences or unsubscribe at any time by visiting our email preference centre or by clicking on the unsubscribe option, both of which are links in each of our emails. View our Privacy & Cookie Policy <a
                        href='${GLOBAL_LINKS[ENV]}/page/privacypolicy'
                        target="_blank"
                        rel="noreferrer noopener"
                        >
                        here</a>. Alternatively, press ESC or refresh the page to 
                        go directly to the site.`,
  ppcSignUp: `By clicking “GO TO DEALS!” you agree to receive daily emails featuring local service, shopping and travel offers from Wowcher. 
              You can change your email preferences or unsubscribe at any time by visiting our email preference centre or by clicking on the unsubscribe option, both of which are links in each of our emails. 
              Alternatively, to go directly to the site, go to <a href='${GLOBAL_LINKS[ENV]}'>www.5pm.co.uk</a> from your browser. 
              View our Privacy & Cookie Policy <a
              href='${GLOBAL_LINKS[ENV]}/page/privacypolicy'
              target="_blank"
              rel="noreferrer noopener"
            >
              here</a>.`,
  risky: 'RISKY',
  saveEightyWhereYouLive: 'Save up to 80% on deals where you live',
  subscriptionEmailIsRequired: 'Subscription email is required',
  toastrMsg: 'An unexpected error occured. Please try again later.',
  undeliverable: 'UNDELIVERABLE',
  unknown: 'UNKNOWN',
};
export const SUBSCRIBER_BUTTONS = {
  close: 'Close',
  login: 'Login',
};
